






















































import Vue from 'vue';
import WorkflowFormInput from '@/components/workflow/WorkflowFormInput.vue';
import WorkflowTextArea from '@/components/workflow/WorkflowTextArea.vue';
import WorkflowFormCheckbox from '@/components/workflow/WorkflowFormCheckbox.vue';
import WorkflowFormDatePicker from '@/components/workflow/WorkflowFormDatePicker.vue';
import WorkflowSignaturePad from '@/components/workflow/WorkflowSignaturePad.vue';
import WorkflowFormSelect from '@/components/workflow/WorkflowFormSelect.vue';
import WorkflowUnsupportedInput from '@/components/workflow/WorkflowUnsupportedInput.vue';
import {
  BaseDocumentSearchModel,
  FieldUpdateModel,
  DynamicFormValidationModel,
  Dictionary,
  DataFieldToUpdateFromListField,
  DynamicFormModel
} from '@/types';
import { mapActions } from 'vuex';
import { EventBus } from '@/classes/EventBus';
import { FieldModel } from '@/types/models/workflowJob/dynamicForm/FieldModel';
import { SimpleFieldModel } from '@/types/models/workflowJob/dynamicForm/SimpleFieldModel';
import Toast from '@/classes/SnotifyConfiguration';

export default Vue.extend({
  name: 'WorkflowDynamicForm',
  props: {
    storeNamespace: {
      type: String,
      required: true
    },
    storeGetter: {
      type: String,
      required: true
    },
    storeAction: {
      type: String,
      required: true
    },
    storeEvaluateFieldRulesAction: {
      type: String
    },
    dynamicFormModel: {
      type: Object,
      required: true
    },
    documentSearchModel: {
      type: Object as () => BaseDocumentSearchModel,
      required: true
    },
    ignoreRequiredFieldsValidation: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    useAltAxis: {
      type: Boolean,
      default: false
    },
    isWorkflowJobLocked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions({
      _setDataField(dispatch, payload) {
        return dispatch(`${this.storeNamespace}/${this.storeAction}`, payload);
      },
      async _evaluateFieldUpdateRules(dispatch, payload) {
        try {
          await dispatch(`${this.storeNamespace}/${this.storeEvaluateFieldRulesAction}`, payload);
        } catch (error) {
          if (error instanceof Error) {
            Toast.showError(error.message);
          }
        }
      }
    }),
    setDynamicFields() {
      const dynamicFields = (this.dynamicFormModel as DynamicFormModel).containerRows
        .flatMap((cr) => cr.containerColumns)
        .flatMap((cc) => cc.fieldRows)
        .flatMap((fr) => fr.fieldColumns)
        .flatMap((fc) => fc.fields);
      this.$store.dispatch('workflowJobStore/setDynamicFields', dynamicFields);
    },
    setDataField(this: any, dataSourceKey: string, fieldName: string, value: string) {
      const dataField = {
        dataSourceKey,
        fieldName,
        value
      } as FieldUpdateModel;
      this._setDataField(dataField);
    },
    onUpdateData(this: any, dataSourceKey: string, fieldName: string, value: string) {
      this.CurrentDataField = {
        dataSourceKey,
        fieldName,
        value
      } as FieldUpdateModel;
      this._setDataField(this.CurrentDataField);
    },
    onFieldWithListSelectionRuleUpdated(this: any, dataFieldsList: any) {
      const failedUpdateDataFields: string[] = [];
      this.setDynamicFields();
      Object.keys(dataFieldsList.row).forEach((field: string) => {
        if (this.CurrentDataField.value) {
          const dataFieldsToUpdateFromListField = dataFieldsList.dataFieldsToUpdateAfterListSelection.filter(
            (x: DataFieldToUpdateFromListField) => x.listField.toLowerCase() === field.toLowerCase()
          );

          dataFieldsToUpdateFromListField.forEach((fieldToUpdate: any) => {
            if (!this.canUpdateDataFields(fieldToUpdate)) {
              failedUpdateDataFields.push(fieldToUpdate.fieldName);
            } else {
              this.setDataField(fieldToUpdate.dataSourceKey, fieldToUpdate.fieldName, dataFieldsList.row[field]);
            }
          });
        }
      });
      if (failedUpdateDataFields.length > 0) {
        Toast.showError(
          `Changing this field caused a List Selection Rule to attempt the update of one or more read-only fields
          , which is not allowed. The read-only fields were not updated`
        );
      }
    },
    canUpdateDataFields(this: any, dataFieldsToUpdateFromListField: any): boolean {
      return this.$store.getters['workflowJobStore/canUpdateDataFields'](dataFieldsToUpdateFromListField);
    },
    onRuleFieldUpdated(this: any) {
      if (this.storeEvaluateFieldRulesAction) {
        this.setDynamicFields();
        this._evaluateFieldUpdateRules(this.CurrentDataField);
      }
    },
    getDataField(this: any, dataSourceKey: string, fieldName: string) {
      return this._getDataField(dataSourceKey, fieldName);
    },
    checkIsLastElement(this: any, index: any, controlList: any) {
      return controlList?.length > 2 && index === controlList?.length - 1;
    }
  },
  computed: {
    _getDataField(this: any): any {
      return this.$store.getters[`${this.storeNamespace}/${this.storeGetter}`];
    },
    getDynamicFields(this: any): FieldModel {
      return this.$store.getters[`${this.storeNamespace}/dynamicFields`];
    },
    getAllFieldData(this: any): any {
      return (field: FieldModel) => {
        const allDataFields = {} as Dictionary<any>;
        if (field?.properties?.additionalProperties?.includeAllFieldData) {
          this.dynamicFormModel.fields.forEach((field: SimpleFieldModel) => {
            allDataFields[field.fieldName] = this.getDataField(field.dataSourceKey, field.fieldName);
          });
        }
        return allDataFields;
      };
    }
  },
  created(this: any) {
    EventBus.$on(`dynamic-form-submit-${this.dynamicFormModel.formId}`, () => {
      this.$refs.validationObserver.validate().then((valid: boolean) => {
        EventBus.$emit('dynamic-form-validated', {
          formId: this.dynamicFormModel.formId,
          valid,
          validated: true
        } as DynamicFormValidationModel);
      });
    });
  },
  beforeDestroy() {
    EventBus.$off(`dynamic-form-submit-${this.dynamicFormModel.formId}`);
  },
  components: {
    WorkflowFormInput,
    WorkflowTextArea,
    WorkflowFormCheckbox,
    WorkflowFormDatePicker,
    WorkflowSignaturePad,
    WorkflowFormSelect,
    WorkflowUnsupportedInput
  }
});
